<template>
  <div class="pointList rtcfStyPad" style="margin-top: 15px;">
    <div class="intes-bt-box" v-show="list.length !== 0">
      <noZklist :list="list" :laiyuan="'renti'"></noZklist>
      <div class="tswz">
        该分析为功能评估，结果不作为临床诊断标准，如需诊断是否患有疾病，请到专业医疗机构进行诊断检查。
      </div>
    </div>

    <div v-show="list.length == 0" style="text-align: center">暂无数据</div>
  </div>
</template>
<script>
import markbox from "./markBox.vue"
import noZklist from "./noZklist.vue"
import EchartsBar from './EchartsBar'

export default {
  props: ['list', 'marks', 'st', 'qsfx'],
  components: {
    markbox, EchartsBar, noZklist
  },
  data () {
    return {
      activeNames: [],

    }
  },
  watch: {
    list (newVal) {
      this.list = newVal;
    }
  },
  methods: {

    handClickFs () {
      this.$emit('fatherMethod');
    }
  }
}
</script>
<style lang="scss" scoped>
.mytab {
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.intes-bt-box {
  padding: 0 30px;
  .intes-bt-box-tit {
    font-size: 24px;
    color: #fff;
    margin-bottom: 16px;
  }
  .mt20 {
    margin-top: 30px;
    font-size: 24px;
    color: #666;
  }
  .tswz {
    font-size: 20px;
    color: #666;
    margin: 30px 0;
    line-height: 30px;
  }
  .zxtjt {
    background: #fff;
    height: 450px;
  }
  .zxtjtr {
    font-size: 20px;
    margin: 30px 0 0 30px;
    color: #8c8c8c;
  }
}
</style>